import { BusinessData, Staff } from "../../types";

export function findAccountPhoto(
  userId: number,
  selectedBusiness: BusinessData | null,
  businesses: BusinessData[],
) {
  if (!(Number(userId) > 0)) return undefined;
  const ownsPhoto = (staff: Staff) =>
    Number(staff.user?.id ?? staff.userId) === Number(userId) && Boolean(staff.image?.url);
  return selectedBusiness?.businessStaffs?.find(ownsPhoto)?.image
    ?? businesses.flatMap((business) => business.businessStaffs ?? []).find(ownsPhoto)?.image;
}
